import React, { memo, useCallback, useContext } from 'react';
import classnames from 'classnames';
import Icon from '../icon';
import ConfigContext from '../config-provider/ConfigContext';
const TabsAddBtn = function TabsAddBtn(props) {
    const { getPrefixCls } = useContext(ConfigContext);
    const { onEdit, prefixCls: customizePrefixCls, extraPrefixCls, vertical = false, isFixed } = props;
    const prefixCls = getPrefixCls('tabs', customizePrefixCls);
    const createNewTab = useCallback((e) => {
        if (onEdit) {
            onEdit(e, 'add');
        }
    }, [onEdit]);
    const classes = classnames(`${prefixCls}-nav-add`, {
        [`${prefixCls}-nav-add-fixed`]: isFixed,
        [`${prefixCls}-nav-vertical-add`]: vertical,
    });
    return (React.createElement("div", { className: classes, style: { display: extraPrefixCls || 'block' }, onClick: createNewTab },
        React.createElement(Icon, { type: "add" })));
};
TabsAddBtn.displayName = 'TabsAddBtn';
export default memo(TabsAddBtn);
